<div class="loadingContainer"
     style="">

  <img width="180" src="../../assets/img/loading.svg" alt="">

  <div class="logo">
    <img src="../../assets/img/GBarena-type.svg" alt="">
  </div>
</div>
